import {
  ACTION_POST_BOOKING_FLIGHTCREDITS,
  ACTION_POST_BOOKING_FLIGHTCREDITS_SUCCESS,
  ACTION_POST_BOOKING_FLIGHTCREDITS_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbar, enqueueSnackbarHandler } from '../Status';
export interface PostFlightCreditParams {
  ticketNumber: string;
  firstName: string;
  lastName: string;
  totalValue: number;
  airline: string;
  bookingId: string;
  expiryDate: Date;
  pnr: string;
}

export function postBookingFlightCredit(params: PostFlightCreditParams) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `booking/flightCredit/${params.bookingId}`,
        method: 'post',
        data: JSON.stringify({ ...params, magnatechStatus: 'EXCHANGED' }) || {},
        success: (response: any) => {
          if (response.type === 'error') {
            const errors = response?.payload?.payload ?? {};
            Object.keys(errors).forEach(function (item) {
              if ((errors[item] ?? false) === true) {
                dispatch(enqueueSnackbar(item, 'error'));
              }
            });
            dispatch(requestFailed(response));
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { postFlightCreditSuccess: true },
              'success',
            ),
              dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          const errors = error?.payload ?? {};
          Object.keys(errors).forEach(function (item) {
            if ((errors[item] ?? false) === true) {
              dispatch(enqueueSnackbar(item, 'error'));
            }
          });
          dispatch(requestFailed(error));
        },
      },
    });
    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_POST_BOOKING_FLIGHTCREDITS,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_POST_BOOKING_FLIGHTCREDITS_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_POST_BOOKING_FLIGHTCREDITS_FAILURE,
    payload: responseJSON,
  };
}
